import { PropsWithChildren, ReactElement, useContext } from 'react';
import { CategoriesContext } from '../App';

interface PageProps {
    home: () => ReactElement | null;
    search: () => ReactElement | null;
    categoryOuter: () => ReactElement | null;
    categoryInner: () => ReactElement | null;
    catalog: () => ReactElement | null;
    product?: () => ReactElement | null;
    notFound: (props: PropsWithChildren<{}>) => ReactElement | null;
}

function Page(props: PageProps) {
    const { pathname, categorySlugs, isProduct } = useContext(CategoriesContext);
    if (isProduct) {
        if (props.product) {
            const Product = props.product;
            return <Product />;
        } else {
            return null;
        }
    }
    if (pathname === '/') {
        const Home = props.home;
        return <Home />;
    }
    if (pathname === '/search/') {
        const Search = props.search;
        return <Search />;
    }
    if (categorySlugs.length === 1) {
        // "/modulnoe_oborudovanie/",
        const CategoryOuter = props.categoryOuter;
        return <CategoryOuter />;
    } else if (categorySlugs.length === 2) {
        // "/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/",
        const CategoryInner = props.categoryInner;
        return <CategoryInner />;
    } else if (categorySlugs.length > 2) {
        const Catalog = props.catalog;
        return <Catalog />;
    }
    const NotFound = props.notFound;
    return <NotFound>Раздел не найден</NotFound>;
}

export default Page;
